import React, { useEffect } from 'react';
import { IconButton, Icon, TablePagination } from '@material-ui/core';
import _ from 'lodash';

export function OptimisticTableFooter(props: any) {
  return (
    <TablePagination
      {...props}
      ActionsComponent={iprops => <Actions {...iprops} icons={props.icons} />}
    />
  );
}

function Actions(props: any) {
  const { onChangePage } = props;

  useEffect(() => {
    function keyEventListener(event: KeyboardEvent) {
      if ((event.target as HTMLElement).tagName.toLowerCase().trim() !== 'body') return;

      switch (event.key) {
        case 'ArrowLeft':
          onChangePage(null, -1);
          break;
        case 'ArrowRight':
          onChangePage(null, 1);
          break;
      }
    }

    const debouncedHanler = _.debounce(keyEventListener, 100);
    document.body.addEventListener('keydown', debouncedHanler);
    return () => document.body.removeEventListener('keydown', debouncedHanler);
  }, [onChangePage]);

  return (
    <>
      <IconButton
        onClick={() => {
          props.onChangePage(null, -1);
        }}
      >
        <Icon component={props.icons['PreviousPage']} />
      </IconButton>
      <IconButton
        onClick={() => {
          props.onChangePage(null, 1);
        }}
      >
        <Icon component={props.icons['NextPage']} />
      </IconButton>
    </>
  );
}
